const FileSaver = require('file-saver');
const JSZip = require('jszip');
import generatorRows from './formatters/rows/generatorRows';
import {contentTypes} from './statics/[Content_Types].xml';
import {contentType} from './statics/contentType.xml';
import {relsXml} from './statics/rels.xml';
import {sheetXML} from './statics/sheet.xml';
import {workbookXML} from './statics/workbook.xml';
import {workbookXMLRel} from './statics/workbook.xml.rel';
import {workbookXMLRels} from './statics/workbook.xml.rels';
import {templateSheet} from './templates/worksheet.xml';
import validator from './validator';

export const generateXMLRels = (sheetNames:Array<string>) =>
{
    const relsXML:string = sheetNames.map(
        (sheetName:string, index:number) => workbookXMLRel.replace(
            /\{index\}/g,
            String(index + 1)
        )
    ).join('');

    return workbookXMLRels.replace(/\{placeholder\}/g, relsXML);
};

export const generateXMLWorksheet = (rows) =>
{
    const XMLRows = generatorRows(rows);
    return templateSheet.replace(/\{placeholder\}/g, XMLRows);
};

export const generateContentTypes = (sheetNames:Array<string>) =>
{
    const contentTypesXML:string = sheetNames.map(
        (sheetName:string, index:number) => contentType.replace(
            /\{index\}/g,
            String(index + 1)
        )
    ).join('');

    return contentTypes.replace(/\{placeholder\}/g, contentTypesXML);
};

export const generateXMLWorkbook = (sheetNames:Array<string>) =>
{
    const sheetsXML:string = sheetNames.map(
        (sheetName:string, index:number) => sheetXML.replace(
            /\{index\}/g,
            String(index + 1)
        ).replace(
            /\{sheetName\}/g,
            sheetName
        )
    ).join('');

    return workbookXML.replace(/\{placeholder\}/g, sheetsXML);
};

export const zipcelx = (config):Promise<boolean> =>
{
    if( !validator(config) )
        return Promise.resolve(false);

    const zip = new JSZip();
    const xl = zip.folder('xl');

    const sheetNames:Array<string> = [];

    config.sheets.forEach((sheet, index:number) =>
    {
        const worksheet = generateXMLWorksheet(sheet.data);

        sheetNames.push(sheet.name ? sheet.name : `Sheet ${index + 1}`);

        xl.file(`worksheets/sheet${index + 1}.xml`, worksheet);
    });

    xl.file('_rels/workbook.xml.rels', generateXMLRels(sheetNames));
    zip.file('_rels/.rels', relsXml);
    zip.file('[Content_Types].xml', generateContentTypes(sheetNames));
    xl.file('workbook.xml', generateXMLWorkbook(sheetNames));

    return zip.generateAsync({
        type: 'blob',
        mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }).then((blob) =>
    {
        FileSaver.saveAs(blob, `${config.filename}.xlsx`);

        return true;
    });
};
